import { StandardOrderProduct } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";
import StandardProductConfig from "../config";

interface Props {
  standardProduct: StandardOrderProduct;
  className?: string;
  index?: number;
}

const StandardProductPaymentDescription = ({
  standardProduct,
  className,
}: Props) => {
  return (
    <div
      className={concatClassnames(
        "gg-mb-6 md:gg-mb-10 lg:gg-mb-0",
        "gg-grid gg-grid-cols-7 lg:gg-flex lg:gg-items-start lg:gg-gap-0",
        className
      )}
    >
      <div
        className={concatClassnames(
          "gg-w-20 gg-h-20 sm:gg-w-32 sm:gg-h-32 lg:gg-w-40 lg:gg-h-40 gg-shrink-0",
          "lg:gg-mr-7 lg:gg-pt-2 gg-mt-2 lg:gg-mt-0",
          "gg-col-span-2 "
        )}
      >
        <OptionConfigurationImage imageId={standardProduct.thumbnailId} />
      </div>

      <div className={concatClassnames("gg-w-full gg-col-span-5")}>
        <Heading headingLevel="h2">
          {standardProduct.name}, {standardProduct.amount} stuk
          {standardProduct.amount > 1 && "s"}
        </Heading>

        <StandardProductConfig standardProduct={standardProduct} />
      </div>
    </div>
  );
};
export default StandardProductPaymentDescription;
